export default __webpack_public_path__ + "img/8cece51e06a33fa33fbfc1d975ddc44b.svg";